import type { EmblaCarouselType } from 'embla-carousel'
import { useCallback } from 'react'

export const usePrevNextButtons = (emblaApi?: EmblaCarouselType) => {
  const onPrevButtonClick = useCallback(
    () => emblaApi?.scrollPrev(),
    [emblaApi]
  )

  const onNextButtonClick = useCallback(
    () => emblaApi?.scrollNext(),
    [emblaApi]
  )

  return { onPrevButtonClick, onNextButtonClick }
}
